import gql from 'graphql-tag'

export const FACILITIES_GRID_QUERY = gql`
  query facilitiesGrid(
    $accountId: Int!
    $page: Int!
    $pageSize: Int!
    $sorts: FacilitiesSort
    $filters: FacilitiesFilters
    $search: String
  ) {
    facilitiesGrid(
      accountId: $accountId
      page: $page
      pageSize: $pageSize
      sorts: $sorts
      filters: $filters
      search: $search
    ) {
      totalPages
      pageSize
      total
      page
      items {
        id
        schoolName
        address
        city
        state
        zip
      }
    }
  }
`
